<template>
  <b-modal id="sampleExample"
           size="lg"
           :ok-only="true"
           :lazy="true"
           title="What’s included in my list?"
           :hide-footer="true">
    <p>Your list order will include the fields listed below, any filters you’ve chosen in building your list, plus any optional fields you choose to include in the output of your list.
    </p>
    <b-tabs>
      <!--<b-tab title="Standard Fields">-->
        <!--<ul>-->
          <!--<li v-for="item in standardFields">{{item}}</li>-->
        <!--</ul>-->
      <!--</b-tab>-->
      <b-tab title="Consumer">
        <p class="example-title">Standard Consumer Fields</p>
        <b-img src="./static/example/consumer.gif" class="example-img" fluid />
        <b-img src="./static/example/consumer-2.gif" class="example-img" fluid />
      </b-tab>
      <b-tab title="Business">
        <p class="example-title">Standard Business Fields</p>
        <b-img src="./static/example/business.gif" class="example-img" fluid />
        <b-img src="./static/example/business-2.gif" class="example-img" fluid />
      </b-tab>
      <b-tab title="New Mover">
        <p class="example-title">Standard New Mover Fields</p>
        <b-img src="./static/example/newmover.gif" class="example-img" fluid />
      </b-tab>
      <b-tab title="New Homeowner">
        <p  class="example-title">Standard New Homeowner Fields</p>
        <b-img src="./static/example/homeowners.gif" class="example-img" fluid />
      </b-tab>
      <!--<b-tab title="Home Data">-->
        <!--<p  class="example-title">Standard Home Data Fields</p>-->
        <!--<b-img src="./static/example/homedata.gif" class="example-img" fluid />-->
      <!--</b-tab>-->
      <b-tab title="Saturation ">
        <p  class="example-title">Standard Saturation Fields</p>
        <b-img src="./static/example/CIS.gif" class="example-img" fluid />
      </b-tab>
    </b-tabs>

    <!--<iframe :src="$store.getters['config/link']('sampleExample')"-->
            <!--class="iframe"-->
            <!--frameborder="0"-->
            <!--scrolling="auto"-->
            <!--marginheight="0" marginwidth="0" >-->
    <!--</iframe>-->
  </b-modal>
</template>

<script>
  export default {
    data () {
      return {
        standardFields: [
          'Prefix Title',
          'Individual Name (Full)',
          'First Name',
          'Middle Initial',
          'Last Name',
          'Address Line',
          'Address Line 2',
          'City',
          'State',
          'ZIP Code',
          'ZIP+4',
          'Delivery Point Code']
      }
    }
  }
</script>

<style scoped lang="scss">
  .example-img {
  }
  .example-title {
    margin-top: 16px;
    margin-bottom: 16px;
  }
</style>
<style>
  @media(min-width: 768px) {
    [aria-labelledby=sampleExample___BV_modal_header_] {
      width: 80vw;
      margin-left: -10vw;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/common/MSampleExample.vue